export enum PaymentQueryKeys {
  getPackageAmount = "get-package-amount",
  adminGetPaymentsByCategory = "admin-get-payments-by-category",
  adminGetPaymentExport = "admin-get-payment-export",
  adminGetOfferPaymentsByCategory = "admin-get-offer-payments-by-category",
  adminGetOfferPaymentExport = "admin-get-offer-payment-export",
}
